import { useState, useEffect } from "react";

function useSessionStorageWatcher(key: string, interval: number = 1000) {
  const [value, setValue] = useState<string | null>(() =>
    sessionStorage.getItem(key)
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentValue = sessionStorage.getItem(key);
      if (currentValue !== value) {
        setValue(currentValue);
      }
    }, interval);

    return () => clearInterval(intervalId);
  }, [key, value, interval]);

  return value;
}

export default useSessionStorageWatcher;
